import TutorProfileSettings from "@/elements/components/profile/tutor-profile-settings";
import Loader from "@/elements/components/shared/loader";
import { api } from "@/elements/components/utils/convex-api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import React, { Fragment } from "react";

function ProfileSettingsScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {})
  );
  const persona = currentUser?.persona;

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return persona === "parent" ? (
    <Fragment />
  ) : persona === "tutor" ? (
    <TutorProfileSettings />
  ) : (
    <Fragment />
  );
}

export default ProfileSettingsScreen;
